module.exports = __webpack_public_path__ + "static/greystar-e978319bdf70847abc501119dd1f045f.jpeg";